export const CREATE_USER_SESSION_API =
  'https://www.kaltura.com/api_v3/service/session/action/start';
export const GET_VIDEO_DATA_API =
  'https://www.kaltura.com/api_v3/service/baseentry/action/get';

export const VIEW_VIDEO_TAG = 'View Video';
export const VIDEO_CHANNEL_TAG = 'Go to this video channel';

export const CLOSE_BUTTON_TAG = 'Close';

export const PARTNER_ID = 2563011;
export const FAKE_SECRET = '1ecae30b83a4d215de80f5a53b844d1c';

export const ENTRY_ID = '1_gtlm8jf4'; //'1_hxh3vnrf'//'1_gtlm8jf4';
export const ENTRY_ID_PLAYLIST = '1_dq71zh42';
export const KS = 'djJ8MjM2MzcyMXxxb0';
export const TEST_LINK = 'https://www.google.com/';
export const PRIVILEGES = 'disableentitlement';

export const VIDEO_FORMAT = 'Video';

export const VIDEO_PLAYER = 'VideoPlayer';
export const VIDEO_PLAY_LIST = 'VideoPlayList';

export const myObject = {
  format: 1,
  type: 2,
  partnerId: PARTNER_ID,
  secret: FAKE_SECRET,
  privileges: PRIVILEGES,
};

export const mockApiResponseVideoPlayList =
  '{"playlistContent":"1_aheyrtnv,1_ae2lu5we,1_h608sp4r,1_c7zmgod0","objectType":"KalturaPlaylist"}';

export const mockApiResponseVideo =
  '{"objectType":"KalturaMediaEntry","rootEntryId":"1_gtlm8jf4","views":290,"duration":0,"name":"Test Video","description":"Test Video Description"}';

export const expectedMyObjectResponse =
  '{"format":1,"type":2,"partnerId":2563011,"secret":"1ecae30b83a4d215de80f5a53b844d1c","privileges":"disableentitlement"}';
